import React from 'react'


const Rell = () => {

  return (
    <div className='w-screen min-h-screen bg-green-500'>
      Rell
    </div>
  )
}

export default Rell